/** Download the offline pack and reconcile the reporter's server-side surveys. */
import { getDeviceId } from '../lib/device';
import { downloadPack, type DownloadPackOptions } from '../lib/sync/pack';
import type { Services } from './services';

export async function refreshPack(s: Pick<Services, 'api' | 'storage' | 'drafts'>, userId: string, deviceId = getDeviceId()) {
  const opts: DownloadPackOptions = {
    known: await s.drafts.syncedEditableIds(),
    onSurveys: async (surveys, pack) => {
      const customerOf = new Map(pack.sites.map((x) => [x.id, x.customerId]));
      await s.drafts.reconcileServerSurveys(surveys, { reporterUserId: userId, deviceId, customerOf: (id) => customerOf.get(id) });
    },
    onWithdrawn: (withdrawn) => s.drafts.markWithdrawn(withdrawn),
  };
  const pack = await downloadPack(s.api, s.storage, opts);
  // Submitted surveys whose data is all on the server leave the device after the grace period (ADR-0028).
  await s.drafts.purgeSynced().catch(() => []);
  return pack;
}
